import { Component, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Keys } from 'app/models/core/dropdowns';
import { ISearchLabs, ISearchLabsParameters } from 'app/models/searchLabs/searchLabs';
import { SettingsService } from 'app/services/core/settings.service';
import { SearchLabsService } from 'app/services/searchLabs/searchLabs.service';

@Component({
  selector: 'searchLabs',
  templateUrl: './searchLabs.component.html',
  styleUrls: ['./searchLabs.component.scss']
})
export class SearchLabsComponent {

  rad = "";
  hideSearch1 = true;
  hideSearch2 = true;
  hideStates = true;
  search1 = "";
  search2 = "";
  labFilter = "";
  list: ISearchLabs[] = [];
  stateList = Keys.stateList;

  form = new UntypedFormGroup({
    searchParam1: new UntypedFormControl('None'),
    searchParam2: new UntypedFormControl('None'),
    search: new UntypedFormControl(''),
    searchAnalytes: new UntypedFormControl(''),
    cannabis: new UntypedFormControl(Boolean, [Validators.maxLength(1)]),
    psilocybin: new UntypedFormControl(Boolean, [Validators.maxLength(1)]),
    dw: new UntypedFormControl(Boolean, [Validators.maxLength(1)]),
    np: new UntypedFormControl(Boolean, [Validators.maxLength(1)]),
    s: new UntypedFormControl(Boolean, [Validators.maxLength(1)]),
    air: new UntypedFormControl(Boolean, [Validators.maxLength(1)]),
    bt: new UntypedFormControl(Boolean, [Validators.maxLength(1)]),
    commercial: new UntypedFormControl(Boolean, [Validators.maxLength(1)]),
  });

  displayedColumns: string[] = ['labName', 'orelapId', 'siteAddress', 
        'siteCity', 'siteState', 'siteZip','sitePhone', 'siteEmail','accreditation'];
  dataSource = new MatTableDataSource<ISearchLabs>(this.list);
  @ViewChild('TablePaginator') paginator: MatPaginator;
  @ViewChild('TableSort') sort: MatSort;

  constructor(public searchLabsService: SearchLabsService, 
    public settings: SettingsService) { }

  filterTable(value: string) {
    this.dataSource.filter = value.trim().toLowerCase();
  }
  ngOnInit(): void {
    this.form.patchValue({
      dw:true,
      commercial:false,
      np:true,
      s:true,
      air:true,
      bt:true,
      cannabis:false,
      psilocybin:false,
    });

    this.dataSource.filter = this.labFilter;
  }

  submitRequest() {
    if (this.form.valid) {
      let params = this.form.value;
      let parameters: ISearchLabsParameters = {
        searchBy1: params.searchParam1,
        searchText1: params.search,
        searchBy2: params.searchParam2,
        searchText2: params.searchAnalytes,
        dw: params.dw,
        np: params.np,
        s: params.s,
        air: params.air,
        bt: params.bt,
        cannabis: params.cannabis,
        psilocybin: params.psilocybin,
        commercial: params.commercial
      }

      this.searchLabsService.getSearchLabs(parameters).subscribe(
        response => {this.list = response;
          this.dataSource.data = this.list;
          this.timeout();
          this.labFilter = '';
        },
        error => console.log('error', error),
        () => {}
      );
    }
  }

  timeout() {
    setTimeout(() => {
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    }, 100);
  }

  clearSearch1(){
    this.form.controls['search'].setValue('');
  }
  clearSearch2(){
    this.form.controls['searchAnalytes'].setValue('');
  }

  searchLabs(){
    console.log('search');
  }

  getExcel(id){
    this.searchLabsService.getSearchFoaReport(id, 'Csv').subscribe(
      response => this.downloadFile("SearchFoaReport.csv", response),
      error => console.log('error', error)
    );
  }

  getPdf(id){
    this.searchLabsService.getSearchFoaReport(id, 'Pdf').subscribe(
      response => this.downloadFile("SearchFoaReport.pdf", response),
      error => console.log('error', error)
    );
  }

  downloadFile(fileName: string, blob: Blob) {
    let file = URL.createObjectURL(blob);
    var fileDownload = document.createElement('a');
    fileDownload.href = file;
    fileDownload.download = fileName;
    fileDownload.click();
  }

  clearFilter() {
    this.labFilter = "";
    this.dataSource.filter = this.labFilter;
  }

  clearRadio1(radioValue){
    this.clearSearch1();
    if (radioValue == "None"){
      this.hideSearch1 = true;
      this.hideStates = true;
    }
    else if (radioValue == "State") 
    {
      this.hideSearch1 = true;
      this.hideStates = false;
    }
    else
    {
      this.hideSearch1 = false;
      this.hideStates = true;
    }
  }

  clearRadio2(radioValue){
    if (radioValue == "None"){
      this.hideSearch2 = true;
    }
    else{
      this.hideSearch2 = false;
    }
  }

  getPageSizeOptions(): number[] {
    if (this.dataSource.data.length > 20) {
      return [10, 20, this.dataSource.data.length];
    } else {
      return [10, 20];
    }
  }

}
